<template>
  <div id='container'>
    <div id='topPart'>
      <div class='block search'>
        <form action="#" @submit='handleSearch' id='searchbox_form' ref='searchboxform'>
          <div class='searchBoxArea'>
            <label for='searchbox' class='searchboxLabel'><img src='/static/search_icon.png'></label>
            <input type='text' id='searchbox' v-model='searchInput' placeholder="Enter a town, city or postcode"/> <!-- old placeholder text: Enter a town, city, region, postcode or store -->
          </div>
          <button type='submit' value='SEARCH'>SEARCH</button>
        </form>
      </div>
      <div class="divided-part">
        <button
          type='button'
          @click="flyToUsersLocation"
          class="is-loading"
        >NEAR ME</button>
        <button
          v-if="!findSpecificProductClicked"
          type='button'
          @click="onClickFindSpecificProduct"
        >FIND A SPECIFIC PRODUCT</button>
        <template v-else>
          <div class='block product-select-area' style='z-index: 6'>
            <!-- <label for='filterbox2'>Showing stores which stock one or more of the selected product(s)</label> -->
            <filter-box
              v-if='productListLoaded'
              :list='productListAsList'
              v-model='productFilterSelection'
              :multiple='true'
              which='retailProducts'
              id='filterbox2'
              singular-text='Product'
              plural-text='Products'
              :select-all-on-mount="false"
              expand-on-mount
            />
          </div>
        </template>
      </div>
    </div>
    <div id='mapContainer'>
      <div id="mapid"></div>
    </div>
    <div class="lds-ring" v-if="userCurrentLocationIsLoading || searchIsLoading"><div></div><div></div><div></div><div></div></div>
    <!--
    <div class="block" id='list_heading'>
      <h1>Full Stockist List</h1>
    </div>
    <div id='list_main' v-if='showFullStockistList'>
      <div class='stockist_list_item' v-for='(store, i) in this.sortedStockists' :key='i'>
        <div class='stockist_list_item_name'>{{store.name}}</div>
        <div v-if='store.derivedAddress' class='stockist_list_item_address'>{{store.derivedAddress}}</div>
        <div v-if='store.googlePlaceID' class="stockist_list_item_googlemaps_link"><a :href="'https://www.google.com/maps/place/?q=place_id:' + store.googlePlaceID" target="_blank">Open in Google Maps for contact details and directions</a></div>
        <div class='stockist_list_item_products'>Products stocked:</div>
        <div v-for='(nothing, productName) in store.products' :key='productName' class='stockist_list_item_products_item'>
          {{productName}}
        </div>
      </div>
    </div>
    <button v-else @click='showFullStockistList = true'>Show the full list of stockists</button>
    -->
  </div>
</template>

<script>
import filterBox from '@/components/filterBox'
import axios from 'axios'
export default {
  name: 'stockistMapExternal',
  components: { filterBox },
  data () {
    return {
      searchInput: '',
      leaflet: window.L,
      map: null,
      retailMarkersSet: new Set(),
      diningMarkersSet: new Set(),
      markerClusterLayer: null,
      retailLocationData: [],
      diningLocationData: [],
      productList: {},
      productListLoaded: false,
      productFilterSelection: [],
      productListAsList: [],
      showFullStockistList: false,
      iconDefinitionRetail: null,
      iconDefinitionDining: null,
      textToShowIfBothRetailAndDining: 'This is a dining stockist as well!',
      timeoutBeforeChangeMap: null,
      findSpecificProductClicked: false,
      userCurrentLocationIsLoading: false,
      searchIsLoading: false,
      locationData: {
        Retail: [],
        Dining: [] // These need to match the stockist types above
      },
      stockistBrandList: [
        // '*Retail', // Means that you can't select this
        'Independent Retailer',
        'Countdown',
        'Fresh Choice',
        'New World',
        'Pak n Save'
        // '*Dining', // Means that you can't select this
        // 'Independent',
        // 'Hell Pizza'
        // 'Domino\'s'
      ],
      stockistBrandSelection: [], // On mount, auto puts all in
      brandRegexes: { // This is how the stockists are split into the different brands
        'Countdown': RegExp('^countdown', 'i'),
        'New World': RegExp('^new world', 'i'),
        'Hell Pizza': RegExp('^hell pizza', 'i'),
        // 'Domino\'s': RegExp('^domino', 'i'),
        'Pak n Save': RegExp('^pak n save', 'i'),
        'Fresh Choice': RegExp('^fresh choice', 'i')
      }
    }
  },
  watch: {
    productFilterSelection: function () {
      if (this.timeoutBeforeChangeMap) {
        clearTimeout(this.timeoutBeforeChangeMap)
      }
      this.timeoutBeforeChangeMap = setTimeout(() => {
        this.displayMap()
      }, 300) // Note that the time here is a bit longer to give more of a chance to make changes
    }
  },
  mounted: function () {
    window.duration = 2
    this.iconDefinitionRetail = new this.leaflet.Icon.Default({imagePath: '/static/retail/'})
    this.iconDefinitionDining = new this.leaflet.Icon.Default({imagePath: '/static/dining/'})
    this.stockistBrandSelection = this.stockistBrandList
    axios.get('https://presto.simplement.services/api/publicAngelfoodStockistMap')
      .then(response => {
        // this.retailLocationData = response.data.retailLocationData
        // this.diningLocationData = response.data.diningLocationData
        response.data.diningLocationData = []
        this.classifyStockistBrands(response.data.retailLocationData, true)
        this.classifyStockistBrands(response.data.diningLocationData)
        this.locationData.Retail = response.data.retailLocationData
        this.locationData.Dining = response.data.diningLocationData
        this.productList = response.data.productList
        this.prepareProductListFilter()
        this.productListLoaded = true
        this.displayMap()
      })
      .catch(error => {
        console.log(error)
        console.log('Suppressed an error, which seems to be because the component calling the axios request no longer exists')
      })
  },
  methods: {
    prepareProductListFilter: function () {
      const productListAsList = []
      for (var productName in this.productList) {
        productListAsList.push(productName)
        this.productFilterSelection.push(productName)
      }
      productListAsList.sort()
      this.productListAsList = productListAsList
    },
    classifyStockistBrands: function (list, isRetail) {
      list.forEach(stockist => {
        /*
        if (isRetail) {
          stockist.isRetail = isRetail
        }
        */
        for (var brandKey in this.brandRegexes) {
          if (this.brandRegexes[brandKey].test(stockist.name)) {
            stockist.brand = brandKey
            break
          }
        }
        // If none, set to Independent
        if (!stockist.brand) {
          if (isRetail) {
            stockist.brand = 'Independent Retailer'
          } else {
            stockist.brand = 'Independent'
          }
        }
      })
    },
    handleSearch: function (e) {
      if (e) {
        e.preventDefault()
      }
      this.searchIsLoading = true
      var inputValue = this.searchInput
      var geocodeReq = {
        region: 'nz'
      }
      if (inputValue.length === 4 && String(parseInt(inputValue)).length === 4) {
        geocodeReq.address = inputValue + ' New Zealand' // This is needed to make post codes work
      } else {
        geocodeReq.address = inputValue
      }
      // TODO - what if the geocoder object isn't ready yet? need to delay and try again in a bit
      try {
        window.geocoder.geocode(geocodeReq, (results, status) => {
          this.searchIsLoading = false
          if (status.valueOf() === 'OK'.valueOf() && results.length > 0) {
            var viewport = results[0]['geometry']['viewport'] // This is what google recommends for this result
            var northeast = [
              viewport.getNorthEast().lat(),
              viewport.getNorthEast().lng()
            ]
            var southwest = [
              viewport.getSouthWest().lat(),
              viewport.getSouthWest().lng()
            ]
            // now move the map
            var latLngBounds = this.leaflet.latLngBounds(southwest, northeast)
            this.map.flyToBounds(latLngBounds, {
              duration: window.duration
            })
          } else {
            console.error()
            throw Error('Geocoding failed: ' + status)
          }
        })
      } catch (error) {
        console.error(error)
        alert('Search by location failed. Perhaps the place could not be found.')
        this.searchIsLoading = false
      }
    },
    displayMap: function () {
      // First remove any existing markers that may have changed
      if (this.markerClusterLayer) {
        this.map.removeLayer(this.markerClusterLayer)
      }
      this.markerClusterLayer = this.leaflet.layerGroup()
      // this.markerClusterLayer = this.leaflet.markerClusterGroup({
      //   showCoverageOnHover: false
      // })
      var selectedProductsObject = {}
      for (var index in this.productFilterSelection) {
        selectedProductsObject[this.productFilterSelection[index]] = true
      }
      console.log('selectedProductsObject: ', selectedProductsObject)
      // console.log('Leaflet object should be here: ', this.leaflet)
      // Initialise the map (only need to do this once)
      if (!this.map) {
        this.leaflet.control.attribution({prefix: false})
        this.map = this.leaflet.map('mapid').setView([-41.28, 174.77], 6)
        var maybeAskFor2x = ''
        if (window.devicePixelRatio > 1) {
          maybeAskFor2x = '@2x'
          console.log('Asking for higher res images')
        }
        // this.leaflet.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}' + maybeAskFor2x + '.png?access_token={accessToken}', {
        // https://api.mapbox.com/styles/v1/andrejl/cjl3ioicb4oq32ql8seytc714/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYW5kcmVqbCIsImEiOiJjajdmdmZwODIxMjhxMnFxdXVpMm1ndmk0In0.S0VZpFWOzaQsf-A6UDI6qQ
        this.leaflet.tileLayer('https://api.mapbox.com/styles/v1/andrejl/cjl3ioicb4oq32ql8seytc714/tiles/256/{z}/{x}/{y}' + maybeAskFor2x + '?access_token={accessToken}', {
          attribution: '', // 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
          maxZoom: 18,
          id: 'mapbox.emerald', // was mapbox.streets until recently
          accessToken: 'pk.eyJ1IjoiYW5kcmVqbCIsImEiOiJjajdmdmZwODIxMjhxMnFxdXVpMm1ndmk0In0.S0VZpFWOzaQsf-A6UDI6qQ'
        }).addTo(this.map)
      }
      var diningPlaceIDs = {}
      this.diningLocationData.forEach(diningLocation => {
        if (diningLocation.googlePlaceID) {
          diningPlaceIDs[diningLocation.googlePlaceID] = true
        }
      })
      // Now add in the markers for the stores
      var brandsSelectedObject = {}
      this.stockistBrandSelection.forEach(brand => {
        brandsSelectedObject[brand] = true
      })
      this.locationData.Retail.forEach(retailStockist => {
        if (brandsSelectedObject[retailStockist.brand]) {
          this.putOnMap(retailStockist, true, selectedProductsObject)
        }
      })
      this.map.addLayer(this.markerClusterLayer)
    },
    putOnMap: function (locationsDataItem, isRetail, selectedProductsObject, diningPlaceIDs) {
      // Need to check for any relevant products first, but only if retail
      var hasASelectedProduct = false
      var thisIconDefinition = this.iconDefinitionDining
      if (isRetail) {
        thisIconDefinition = this.iconDefinitionRetail // Override
        for (var productCode in locationsDataItem.products) {
          if (selectedProductsObject[productCode]) {
            hasASelectedProduct = true
            // This is not so efficient... Extra unneccessary loops
          }
        }
      }
      if (hasASelectedProduct || !isRetail) {
        var latLong = [parseFloat(locationsDataItem.latitude), parseFloat(locationsDataItem.longitude)]
        var marker = this.leaflet.marker(latLong, {
          icon: thisIconDefinition
        })
        this.markerClusterLayer.addLayer(marker)
        var isBothRetailAndDining = false
        if (diningPlaceIDs && isRetail && diningPlaceIDs[locationsDataItem]) {
          // This is one of those that is dining and retail
          isBothRetailAndDining = true
          this.retailMarkersSet.add(marker)
        } else if (isRetail) {
          this.retailMarkersSet.add(marker)
        } else {
          this.diningMarkersSet.add(marker)
        }
        var dynamicGeneratePopup = (function (locationsDataItem, generatePopupText, isRetail, isBothRetailAndDining) {
          return function () {
            // This save time by only generating the content for popups at the moment it is needed
            return generatePopupText(locationsDataItem, isRetail, isBothRetailAndDining)
          }
        })(locationsDataItem, this.generatePopupText, isRetail, isBothRetailAndDining)
        marker.bindPopup(dynamicGeneratePopup)
        // this.markersSet.add(marker)
      }
    },
    generatePopupText: function (locationsDataItem, isRetail, isBothRetailAndDining) {
      // console.log('GENERATING popup content now')
      var popupText = '<div class="popup_storeName">' + locationsDataItem['name'] + '</div>'
      if (locationsDataItem['derivedAddress']) {
        popupText = popupText + '<div class="popup_address">' + locationsDataItem['derivedAddress'] + '</div>'
      }
      if (locationsDataItem['googlePlaceID']) {
        popupText = popupText + '<div class="google_link_area"><a href="https://www.google.com/maps/place/?q=place_id:' + locationsDataItem['googlePlaceID'] + '" target="_blank">Open in Google Maps for contact details and directions</a></div>'
      }
      if (isRetail) {
        popupText = popupText + '<div class="popup_products">' + 'Products stocked:'
        var productCodesForStore = []
        for (var productCode in locationsDataItem.products) {
          productCodesForStore.push(productCode)
        }
        productCodesForStore.sort() // Sort alphabetically (for now at least)
        for (var i in productCodesForStore) {
          popupText = popupText + '<div class="popup_products_product">' + productCodesForStore[i] + '</div>'
          // Assuming that the server has translated our product codes into public friendly names
        }
        popupText = popupText + '</div>'
        if (isBothRetailAndDining) {
          popupText = popupText + '<div>' + this.textToShowIfBothRetailAndDining + '</div>'
        }
      }
      return popupText
    },
    onClickFindSpecificProduct () {
      this.productFilterSelection = []
      this.findSpecificProductClicked = true
    },
    flyToUsersLocation () {
      // Now ask for the user's location
      this.userCurrentLocationIsLoading = true
      const options = {
        timeout: 25 * 1000, // 25 seconds max
        maximumAge: 30 * 60 * 1000 // Accept the location as of like 10 or 30 mins ago (this is milliseconds)
      }
      navigator.geolocation.getCurrentPosition(
        position => {
          this.map.flyTo(this.leaflet.latLng(position.coords.latitude, position.coords.longitude), 12)
          this.userCurrentLocationIsLoading = false
        },
        error => {
          this.userCurrentLocationIsLoading = false
          console.error(error)
          alert('Unable to determine your location. This may be because you have not granted this website permission to access your location information.')
        },
        options
      )
    }
  },
  computed: {
    sortedStockists: function () {
      // For now, just sorting by name, would be nice to do by region also
      var tempArray = []
      var outputArray = []
      var indexMap = new Map()
      for (var i in this.locationsData) {
        indexMap.set(this.locationsData[i].name, i)
        tempArray.push(this.locationsData[i].name)
      }
      tempArray.sort()
      for (var j in tempArray) {
        var itemIndex = indexMap.get(tempArray[j])
        outputArray.push(this.locationsData[itemIndex])
      }
      return outputArray
    }
  }
}
</script>

<style>
#container {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif
}
#container .pretty {
  line-height: 0.7
}
#topPart {
  display: grid;
  background-color: #fffff5;
  grid-template-columns: auto auto;
}
@media screen and (max-width: 1000px) {
  #topPart {
    grid-template-columns: auto;
  }
  #topPart .divided-part button, #topPart .divided-part .filterBox {
    margin-top: 0;
    margin-left: 0
  }
}
#mapid {
  z-index: 5;
  width: 100%;
  height: 100%
}
#mapContainer {
  flex: 1;
}
label {
  text-align: left;
  margin-left: 1em;
  padding: 0.2em;
  font-size: 1.1em;
}
label.checkboxLabel {
  margin-right: 1em;
  margin-left: 0
}
#searchbox_form {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: nowrap;
  flex: 1;
  /* border-right: 1px #b0d25e solid; */
}
#searchbox_form input {
  flex-grow: 1;
  margin: 1rem;
  font-size: 1.2rem;
  padding: 0.5rem;
  min-width: 320px;
  padding-left: 2rem;
  border: 1px solid gray;
}

@media screen and (max-width: 700px) {
  #searchbox_form input {
    min-width: initial;
    font-size: 0.9em
  }
  label {
    font-size: 1em; /* to match input */
  }
  #topPart button {
    padding: 0.5rem;
    font-size: 0.9em
  }
}
.searchBoxArea {
  position: relative;
  display: flex;
  flex-grow: 1
}
.searchboxLabel {
  position: absolute;
  top: 1.5em;
  left: 0.5em
}
.searchboxLabel img {
  height: 1.6em;
}
button {
  margin: 0 1rem 0 0;
  color: #fffff4;
  font-weight: 700;
  border: none;
  background-color: #b0d25e;
  font-size: 16px;
  padding: 12px 18px;
  transition: background-color 170ms ease-out;
  cursor: pointer;
}
button:hover {
  background-color: rgba(176,210,94,.8)
}
.block {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center
}
.block.heading {
  margin-right: 2em
}
h1 {
  padding: 0 1em
}
.block.search {
  flex: 1
}
#stockistMap {
  height: 100%;
  margin: 0;
}

.popup_storeName, .stockist_list_item_name {
  font-weight: bold;
  font-size: 1.3em
}

.popup_products, .stockist_list_item_products {
  font-size: 1.05em;
  margin-top: 1em
}

.popup_products_product, .stockist_list_item_products_item {
  font-size: 1.1em;
  display: flex;
}

#list_main {
  text-align: left;
}
.stockist_list_item {
  margin: 1em
}

@media only screen and (max-width: 600px) {
  body {
      font-size: 0.9em;
  }
}

/* @media screen and (max-width: 800px) {
  .block.search {
    flex-basis: 100%
  }
} */

@media only screen and (max-width: 1300px) {
  body {
      font-size: 0.95em;
  }
}

button {
  font-family: "Francois One", sans-serif;
  letter-spacing: .12em;
}

/* Checkbox style with help from: https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3 */
.checkbox input[type="checkbox"] {
    opacity: 0;
}
.checkbox label::before{
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    border: 1px solid gray;
}
.checkbox label::after {
    content: "";
    display: inline-block;
    height: 4px;
    width: 9px;
    border-left: 2px solid #fffff4;
    border-bottom: 2px solid #fffff4;
    /* borders made to look like a checkmark */
    transform: rotate(-45deg);
}
.checkbox input[type="checkbox"].partial + label::after {
    content: "";
    display: inline-block;
    height: 4px;
    width: 10px;
    border-left: none;
    border-bottom: 2px solid #fffff4;
    /* borders made to look like a checkmark */
    transform: rotate(0deg);
}
.checkbox label {
    position: relative;
}
.checkbox label::before,
.checkbox label::after {
    position: absolute;
}
/*Outer-box*/
.checkbox label::before {
    left: -20px;
    top: 1px;
}
/*Checkmark*/
.checkbox label::after {
    left: -16px;
    top: 5px;
}
/*Hide the checkmark by default*/
.checkbox input[type="checkbox"] + label::after {
    content: none;
}
/*Unhide the checkmark on the checked state*/
.checkbox input[type="checkbox"]:checked + label::after,
.checkbox input[type="checkbox"].partial + label::after {
    content: "";
}
.checkbox input[type="checkbox"]:checked + label::before,
.checkbox input[type="checkbox"].partial + label::before {
    content: "";
    background: #b0d25e;
    border-color: #b0d25e
}
/*Adding focus styles on the outer-box of the fake checkbox*/
.checkbox input[type="checkbox"]:focus + label::before {
    outline: rgb(59, 153, 252) auto 5px;
}
.product-select-area .summary, .product-select-area .filterItemList {
  min-width: 250px;
}
.divided-part {
  /* margin-right: 2rem; */
  /* partially for the loading spinner to have some space */
  display: flex;
  padding-left: 1em;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  position: relative;
}
.divided-part button {
  margin: 1rem
}
.lds-ring {
  position: absolute;
  left: calc(50% - 40px);
  top: 50%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/stockistMapExternal.vue